import './style.css'
import React from 'react'
import { batch, useSelector } from 'react-redux'
import { measureTimingEnd } from 'data/metrics'
import { getViewState } from 'data'
import { NOTE_VIEW } from 'components/viewNames'

import Panels from './Panels'

export default function CommentPanelContainer({
  noteId,
  threadId,
  trackOpenComments,
  fetchNoteActivities,
}) {
  React.useEffect(
    function onMount() {
      batch(() => {
        trackOpenComments()
        measureTimingEnd('TIME_TO_OPEN_COMMENTS')
        fetchNoteActivities({ noteId }) // Allow to see note writers for the NotificationAudienceHelper component
      })
    },
    [noteId, trackOpenComments, fetchNoteActivities]
  )

  // Wait for threads to be loaded
  const isLoading = useSelector(state => getViewState(state, NOTE_VIEW).loading)

  if (!noteId || isLoading) {
    return null
  }

  return <Panels noteId={noteId} threadId={threadId} />
}
